import { Message }  from 'element-ui'

var messageInstance = null;

let $message = options => {
  if (messageInstance) {
    messageInstance.close()//先把原来的关闭
  }
  messageInstance = Message({
    ...options,
    offset: 70,
    showClose: true
  });
  
};

//重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 70,
        showClose: true
      };
    }
    options.type = type;
    if (messageInstance) {
      messageInstance.close()//先把原来的关闭
    }
    messageInstance = Message(options);
  };
});
export default $message
